// @flow

import type { PendingIncomingPayment } from './types';

export function getSafeDueDate(incomingPayment: PendingIncomingPayment): string {
  const dueDate = incomingPayment['due_date'];
  if(!dueDate){
    throw new Error('Due Date: no due date in incoming payment');
  }
  return dueDate;
}
